module.exports = __webpack_public_path__ + "img/resource-zj.2d0743c2.png";